import React, {memo, useEffect, useState} from 'react';
import {useTheme} from "../../../common/ProjectThemeProvider";
import {useToast} from "../../../common/fusion-ui/provider/ToastProvider";
import {getJsonValue, isBoolTrue, setTabTitle} from "../../../common/fusion-ui/utils/ReactUtils";
import {printError, printLog} from "../../../common/CommonUtils";
import {AdminModules} from "../../config/AdminConfig";
import {AdminInterface} from "../../components";

const DbMaintenancePage = memo(() => {
    const TAG = "DbMaintenancePage";

    const moduleName = AdminModules.DbMaintenance;

    const theme = useTheme();
    const {showToast, changeToastVariant} = useToast();

    const Fields = {
        something: 'something',
    };
    const [fieldsData, setFieldsData] = useState({});


    useEffect(() => {
        setTabTitle(moduleName);
    }, []);

    return (<>
            <AdminInterface moduleName={moduleName} tag={TAG}>
                <div className={``}
                >
                    {TAG}
                </div>
            </AdminInterface>
        </>
    )

    function requestMethod() {
        const fun = 'requestMethod:';
        try {

        } catch (error) {
            logErr(fun, error);
        }
    }

    function updateField(field, value) {
        setFieldsData(prevState => ({...prevState, [field]: value}));
    }

    function getField(field, defValue) {
        return getJsonValue(fieldsData, field, defValue);
    }

    function isFieldTrue(field) {
        return isBoolTrue(getField(field), true, true);
    }

    function toast(text, variant) {
        showToast(text + '');
        changeToastVariant(variant);
    }

    function log(...text) {
        printLog(TAG, ...text);
    }

    function logErr(...text) {
        printError(TAG, ...text);
    }
});
export default DbMaintenancePage;
